import { jsxs, jsx } from "react/jsx-runtime";
import Head from "next/head";
import React from "react";
import { useTheme } from "styled-components";
const mediaBreakpointHelper = (breakpoints, breakpoint) => {
  const split = breakpoint.split("_");
  const shirtSize = split[0];
  const strategy = split[1] || "gte";
  if (!breakpoints) {
    return "all";
  }
  const keys = Object.keys(breakpoints);
  const value = breakpoints[shirtSize];
  const index = keys.indexOf(shirtSize);
  if (index < 0) {
    throw new Error(`The breakpoint size '${shirtSize}' does not exist on the theme. Use one of ${keys.map((k) => `'${k}'`).join(", ")}.`);
  }
  if (["lte", "eq", "gte"].indexOf(strategy) < 0) {
    throw new Error(`The strategy '${strategy}' is not valid for breakpoint '${breakpoint}'. Use one of '${shirtSize}_lte', '${shirtSize}_eq', '${shirtSize}_gte'.`);
  }
  let min = "";
  if (strategy !== "lte") {
    min = `(min-width: ${value}px)`;
  }
  let max = "";
  if (strategy !== "gte" && index < keys.length - 1) {
    max = `(max-width: ${breakpoints[keys[index + 1]] - 1}px)`;
  }
  if (min || max) {
    return `${min}${min && max ? " and " : ""}${max}`;
  }
  return "all";
};
function withPreload(Component, options) {
  const {
    as = "image"
  } = options || {};
  return function WithPreloadComponent(props) {
    const {
      src,
      srcSet,
      media,
      loading = "eager"
    } = props;
    const theme = useTheme();
    return /* @__PURE__ */ jsxs(React.Fragment, { children: [
      loading === "eager" && /* @__PURE__ */ jsx(Head, { children: /* @__PURE__ */ jsx("link", { rel: "preload", href: src || srcSet, as, media: media ? mediaBreakpointHelper(theme.constellation.breakpoints, media) : null }) }),
      /* @__PURE__ */ jsx(Component, { ...props })
    ] });
  };
}
export {
  withPreload as default
};
